export const subtleversatile = {
  name: 'Subtle & Versatile',
  color: [0.7490196078431373, 0.8627450980392157, 0.8117647058823529, 1],
  bg: [0.17254901960784313, 0.2901960784313726, 0.3215686274509804, 1],
  grid1: [0.8784313725490196, 0.34509803921568627, 0.34509803921568627, 1],
  grid2: [0.8352941176470589, 0.788235294117647, 0.6941176470588235, 1],
}
